export let Type;

(function (Type) {
  Type["Relationship"] = "relationship";
  Type["Charge"] = "charge";
  Type["Invoice"] = "invoice";
  Type["Service"] = "service";
})(Type || (Type = {}));

export let AgreementState;

(function (AgreementState) {
  AgreementState["Sent"] = "sent";
  AgreementState["Reviewed"] = "reviewed";
  AgreementState["MicroDepositStarted"] = "microDepositStarted";
  AgreementState["MicroDepositStartedV2"] = "microDepositStartedV2";
  AgreementState["MicroDeposit"] = "microDeposit";
  AgreementState["MicroDepositFailed"] = "microDepositFailed";
  AgreementState["MicroDepositFailedV2"] = "microDepositFailedV2";
  AgreementState["MicroDepositVerified"] = "microDepositVerified";
  AgreementState["MicroDepositVerifiedV2"] = "microDepositVerifiedV2";
  AgreementState["PaymentMethod"] = "paymentMethod";
  AgreementState["Approved"] = "approved";
  AgreementState["Terminated"] = "terminated";
  AgreementState["Changed"] = "changed";
  AgreementState["ChangesApproved"] = "changesApproved";
  AgreementState["ChangesAutoApproved"] = "changesAutoApproved";
  AgreementState["StoppedAutoApproval"] = "stoppedAutoApproval";
  AgreementState["SigningReminderSent"] = "signingReminderSent";
  AgreementState["SigningReminderSentManual"] = "signingReminderSentManual";
  AgreementState["MicroDepositReminderSent"] = "microDepositReminderSent";
  AgreementState["PaymentMethodChanged"] = "paymentMethodChanged";
  AgreementState["SignedExternally"] = "signedExternally";
  AgreementState["RequestedPaymentMethod"] = "requestedPaymentMethod";
  AgreementState["LegalTermsUpdated"] = "legalTermsUpdated";
  AgreementState["AmendmentsApprovalMethodUpdated"] = "amendmentsApprovalMethodUpdated";
  AgreementState["TitleUpdated"] = "titleUpdated";
  AgreementState["ManualPaymentsUpdated"] = "manualPaymentsUpdated";
  AgreementState["CoverCreditCardFeesUpdated"] = "coverCreditCardFeesUpdated";
})(AgreementState || (AgreementState = {}));

export let Channel;

(function (Channel) {
  Channel["Email"] = "email";
  Channel["Sms"] = "sms";
})(Channel || (Channel = {}));

export let ChargeState;

(function (ChargeState) {
  ChargeState["Created"] = "created";
  ChargeState["Canceled"] = "canceled";
  ChargeState["Approved"] = "approved";
})(ChargeState || (ChargeState = {}));

export let InvoiceState;

(function (InvoiceState) {
  InvoiceState["Voided"] = "voided";
  InvoiceState["Completed"] = "completed";
  InvoiceState["IssuedIncomplete"] = "issuedIncomplete";
  InvoiceState["Issued"] = "issued";
  InvoiceState["PaymentFailed"] = "paymentFailed";
  InvoiceState["PaymentRetried"] = "paymentRetried";
  InvoiceState["Paid"] = "paid";
  InvoiceState["PaidExternally"] = "paidExternally";
  InvoiceState["DisputeResolved"] = "disputeResolved";
  InvoiceState["Approved"] = "approved";
  InvoiceState["Resent"] = "resent";
  InvoiceState["PaymentConfirmed"] = "paymentConfirmed";
  InvoiceState["PaymentProcessing"] = "paymentProcessing";
  InvoiceState["InvoiceIntegrationCreated"] = "invoiceIntegrationCreated";
  InvoiceState["InvoiceIntegrationSyncFailed"] = "invoiceIntegrationSyncFailed";
  InvoiceState["InvoiceIntegrationPaymentCreated"] = "invoiceIntegrationPaymentCreated";
  InvoiceState["InvoiceIntegrationPaymentSyncFailed"] = "invoiceIntegrationPaymentSyncFailed";
  InvoiceState["InvoiceIntegrationVoided"] = "invoiceIntegrationVoided";
  InvoiceState["Refunded"] = "refunded";
  InvoiceState["PaymentStoppedOLD"] = "disputed";
  InvoiceState["PaymentStopped"] = "paymentStopped";
  InvoiceState["PaymentResumed"] = "paymentResumed";
  InvoiceState["PaymentDisputed"] = "paymentDisputed";
})(InvoiceState || (InvoiceState = {}));

export let ServiceState;

(function (ServiceState) {
  ServiceState["Created"] = "created";
  ServiceState["Changed"] = "changed";
  ServiceState["Approved"] = "approved";
  ServiceState["AutoApproved"] = "autoApproved";
  ServiceState["ChangesApproved"] = "changesApproved";
  ServiceState["ChangesAutoApproved"] = "changesAutoApproved";
  ServiceState["Paused"] = "paused";
  ServiceState["Resumed"] = "resumed";
  ServiceState["Terminated"] = "terminated";
  ServiceState["Canceled"] = "canceled";
  ServiceState["BillCommandDeliverablesPendingApproval"] = "billCommandDeliverablesPendingApproval";
  ServiceState["BillCommandDeliverablesApproved"] = "billCommandDeliverablesApproved";
  ServiceState["BillCommandDeliverablesRejected"] = "billCommandDeliverablesRejected";
  ServiceState["BillCommandDeliverablesWithdrawn"] = "billCommandDeliverablesWithdrawn";
  ServiceState["ChangesDiscarded"] = "changesDiscarded";
})(ServiceState || (ServiceState = {}));

export let RecurrencePeriod;

(function (RecurrencePeriod) {
  RecurrencePeriod["Monthly"] = "monthly";
  RecurrencePeriod["Quarterly"] = "quarterly";
  RecurrencePeriod["Yearly"] = "yearly";
})(RecurrencePeriod || (RecurrencePeriod = {}));

export let Trigger;

(function (Trigger) {
  Trigger["RepeatableManual"] = "repeatableManual";
  Trigger["OneTimeManual"] = "oneTimeManual";
  Trigger["OnApproval"] = "onApproval";
  Trigger["Ongoing"] = "ongoing";
})(Trigger || (Trigger = {}));